// extracted by mini-css-extract-plugin
export var SectionTitle = "bF_d9";
export var active = "bF_fb";